import { gql } from '@apollo/client';

const REQUEST_PASSWORD_CHANGE_EMAIL = gql`
  mutation requestPasswordChangeEmail {
    requestPasswordChangeEmail {
      success
    }
  }
`;

export default REQUEST_PASSWORD_CHANGE_EMAIL;
